import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import CloudUpload from '@mui/icons-material/CloudUpload';

interface ExportActionBarProps {
  hint: string;
  submitting: boolean;
  disabled: boolean;
}

/** Sticky footer with a summary of the export and the submit button; place inside the form. */
const ExportActionBar: React.FC<ExportActionBarProps> = ({ hint, submitting, disabled }) => (
  <Box
    sx={{
      position: 'sticky',
      bottom: 16,
      zIndex: 4,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 2,
      py: 1.5,
      pr: 1.5,
      pl: 2.5,
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'divider',
      borderRadius: 4,
      boxShadow: '0 6px 24px rgba(0,21,41,.10)',
    }}
  >
    <Typography aria-live="polite" sx={{ fontSize: 13, color: 'text.secondary' }}>
      {hint}
    </Typography>
    <Button
      type="submit"
      variant="contained"
      disabled={disabled || submitting}
      aria-busy={submitting}
      startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : <CloudUpload />}
      sx={{ ml: 'auto', height: 48, pl: 2.5, pr: 3, borderRadius: 6, fontSize: 15, fontWeight: 600, boxShadow: '0 1px 2px rgba(0,21,41,.15)' }}
    >
      {submitting ? 'Creating job…' : 'Create export job'}
    </Button>
  </Box>
);

export default ExportActionBar;
